import {RouteContext} from "../../../RouteContext";
import {ListPage} from "../../common/ListPage";
import React from "react";
import {Column, Row} from "../../common/Layout";
import {ShoppingMainKeywordIO} from "../../../../io/content/ShoppingMainKeywordIO";
import {ShoppingMainKeywordValueObject} from "../../../../model/vo/content/ShoppingMainKeywordValueObject";
import {Button} from "@fluentui/react-components";
import {AddFilled} from "@fluentui/react-icons";

export default function List(props: RouteContext) {

    return <>
        <Column gap={'16px'}>
            <Row>
                <Button
                    as={'a'}
                    appearance={'primary'}
                    icon={<AddFilled />}
                    href={'/admin/shoppings/mainKeywords/exposedAt'}
                    target={'_blank'}>
                    메인키워드 다수 생성
                </Button>
            </Row>
            <ListPage
                {...props}
                description={ShoppingMainKeywordValueObject.description}
                list={ShoppingMainKeywordIO.list}
                count={ShoppingMainKeywordIO.count}
                delete={ShoppingMainKeywordIO.delete}
                postHref={'/admin/shoppings/mainKeywords/post'}
                detailHref={item => `/admin/shoppings/mainKeywords/${item.id}`}
                editHref={item => `/admin/shoppings/mainKeywords/edit/${item.id}`}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
            />

        </Column>
    </>
}